module.exports = __webpack_public_path__ + "img/hk_idCard.aa0734f8.png";